import { c as _c } from "react/compiler-runtime";
import { ListItemCardMobile } from "@components/common/mobile/list-item-card-mobile";
import { NO_TRANSLATE_CLASS } from "@flat-ui";
import { useDateTime } from "@hooks/use-date-time";
import { SNAPSHOTS_TABLE_COLUMN_LABELS } from "@pages/project-details/project-snapshots/snapshots-table-constants";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
/**
 * @returns A card with information of the passed snapshot for the snapshot list in mobile view.
 */
export function SnapshotListItemCardMobile(t0) {
  const $ = _c(17);
  const {
    snapshot,
    onCardClick,
    menuItems
  } = t0;
  const {
    formatDateWithTooltip
  } = useDateTime();
  let t1;
  if ($[0] !== formatDateWithTooltip || $[1] !== snapshot.createdAt) {
    t1 = formatDateWithTooltip(snapshot.createdAt);
    $[0] = formatDateWithTooltip;
    $[1] = snapshot.createdAt;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    displayDate,
    tooltipDate
  } = t1;
  const accessLevel = FaroCoreApiUtils.Project.AccessLevelDisplayNames[snapshot.accessLevel];
  let t2;
  if ($[3] !== snapshot.name) {
    t2 = <span className={NO_TRANSLATE_CLASS}>{snapshot.name}</span>;
    $[3] = snapshot.name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== displayDate) {
    t3 = <>{SNAPSHOTS_TABLE_COLUMN_LABELS.created}<span className={NO_TRANSLATE_CLASS}>: {displayDate}</span></>;
    $[5] = displayDate;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== tooltipDate) {
    t4 = tooltipDate ? <var>{tooltipDate}</var> : undefined;
    $[7] = tooltipDate;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== accessLevel || $[10] !== menuItems || $[11] !== onCardClick || $[12] !== snapshot || $[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t5 = <ListItemCardMobile item={snapshot} image={null} title={t2} onCardClick={onCardClick} subtitle={t3} subtitleTooltip={t4} secondaryText={accessLevel} menuItems={menuItems} />;
    $[9] = accessLevel;
    $[10] = menuItems;
    $[11] = onCardClick;
    $[12] = snapshot;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}